import { useEffect } from 'react';

import styled from 'styled-components';
import useLocalStorage from '../../hooks/useLocalStorage';
import useMboClassesQuery from '../../hooks/useMboClassesQuery';
import useTracking from '../../hooks/useTracking';
import { EventNames, ScreenNames } from '../../utils/trackingEvents';
import { Chat } from '../Chat';
import { ChatProvider, ChatSize } from '../Chat/Context';
import Container from '../reusable/Container';
import { GlobalBanners, GlobalBannerType } from '../reusable/GlobalBanners';
import { Header } from '../reusable/Header';
import Text, { TextKind } from '../reusable/Text';
import ClassList from './ClassList';
import { ClassesAppliedFilters } from './Filters/AppliedFilters';
import { FiltersHeader } from './Filters/FiltersHeader';
import { FiltersSidebar } from './Filters/FiltersSidebar';

const StyledContent = styled.main`
  display: flex;
  gap: 32px;
`;

const Classes = () => {
  const { track } = useTracking();
  useEffect(() => {
    track(EventNames.ScreenView, {
      screen_name: ScreenNames.ClassesView,
    });
  }, [track]);

  const [showFilters, setShowFilters] = useLocalStorage(
    'classesFilters',
    false,
  );

  const {
    classes,
    loading,
    isFetchingMore,
    hasNextPage,
    classCount,
    error,
    loadMoreClasses,
  } = useMboClassesQuery();

  return (
    <ChatProvider initialChatSize={ChatSize.Closed}>
      <Header showNavigation />
      <GlobalBanners
        enableBanners={[
          GlobalBannerType.SetupConnections,
          GlobalBannerType.JoinSession,
        ]}
      />
      <Container>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
          <Text kind={TextKind.TitleL}>Classes</Text>
          <FiltersHeader
            isExpanded={Boolean(showFilters)}
            toggleShowSidebar={() => setShowFilters(!showFilters)}
          />
          <StyledContent>
            {showFilters && <FiltersSidebar />}
            <div style={{ flex: 1 }}>
              <ClassesAppliedFilters />
              <ClassList
                classes={classes}
                count={classCount}
                loading={loading}
                isFetchingMore={isFetchingMore}
                hasNextPage={hasNextPage}
                error={error}
                loadMoreClasses={loadMoreClasses}
              />
            </div>
          </StyledContent>
        </div>
      </Container>
      <Chat closeable />
    </ChatProvider>
  );
};

export default Classes;
